/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(catchError((error: HttpErrorResponse) => {
      const isSellerRequest = req.headers.has('X-Seller-Request');
      
         if (req.url.includes('/ssk/login')) {
          return throwError(() => error);
        }

        if (!isSellerRequest && error.status === 401) {
	
          // if logout clear local storage by Raja :) 06-10-21
          if (localStorage.getItem("loginuser") == "patientlogin") {
            let userId = localStorage.getItem("wardUserId");
            let priceList = localStorage.getItem("wardWisePrice");
            localStorage.clear();
            localStorage.setItem("wardWisePrice", priceList);
            localStorage.setItem("wardUserId", userId);
            this.router.navigate(['auth/patient-portal']);
          }
          else {
            let userId = localStorage.getItem("wardUserId");
            let priceList = localStorage.getItem("wardWisePrice");
            localStorage.clear();
            localStorage.setItem("wardWisePrice", priceList);
            localStorage.setItem("wardUserId", userId);
            this.router.navigate(['auth/login']);
          }       
 

        }
        // TODO: handle 403 error ?
        return throwError(error);
      }));
  }
}
